import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import ContentItem from '@/modules/corporate/modules/path/views/PathEditor/components/ContentItem';
import { ContentEntity, DueDateNestingLevelEnum } from '@/types/schema';

import { RenderDueDate } from '../../renderer';
import { AdaptedNestedDueDateConfig } from '../ContentAndCollectionList/hooks/useContentAndCollectionList';

interface ChildResourceProps {
  childResource: ContentEntity;
  dueDateNestingLevel: DueDateNestingLevelEnum;
  onSetDueDateForContent: (
    content: ContentEntity,
    dueDateNestingLevel?: DueDateNestingLevelEnum | undefined,
    isNested?: boolean,
  ) => void;
  nestedDueDateConfig: AdaptedNestedDueDateConfig;
  className?: string;
}

function ChildResource(props: ChildResourceProps) {
  const { t } = useTranslation();
  const {
    childResource,
    dueDateNestingLevel,
    onSetDueDateForContent,
    nestedDueDateConfig,
    className,
  } = props;
  const onSetContentDueDate = useCallback(() => {
    onSetDueDateForContent(childResource, undefined, true);
  }, [childResource, onSetDueDateForContent]);

  return (
    <Stack alignItems="center" className={cn('py-16', className)} justifyContent="between">
      <ContentItem content={childResource} />
      {dueDateNestingLevel === DueDateNestingLevelEnum.Contents ? (
        <RenderDueDate
          selectedDueDate={nestedDueDateConfig?.[childResource.id]?.dueDateConfig}
          t={t}
          onClick={onSetContentDueDate}
        />
      ) : null}
    </Stack>
  );
}

export default ChildResource;
